import dynamic from 'next/dynamic';
import { FC } from 'react';

interface IPosterContent {
  pdfUrl: string;
}

const PdfViewer = dynamic(() => import('@/components/ui/shared/pdf/PdfViewer/PdfViewer').then((mod) => mod.PdfViewer), {
  ssr: false,
});

export const PdfContent: FC<IPosterContent> = ({ pdfUrl }) => {
  return <PdfViewer src={pdfUrl} h="full" />;
};
